import { createHook, createStore } from 'react-sweet-state';
import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils';
import { SERVICE_DESK } from '@atlassian/jira-shared-types';
import { useLicensedProducts } from '@atlassian/jira-tenant-context-controller';
import { actions, type Actions } from './actions';
import type { State } from './types';

export const store = createStore<State, Actions>({
	name: 'IsYourWorkTourCompleted',
	initialState: {
		isCompleted: false,
	},
	actions,
});

const useStore = createHook(store);

const useActions = createHook(store, { selector: null });

export const useSetIsYourWorkTourCompleted = () => {
	const [, { setIsCompleted }] = useActions();

	return setIsCompleted;
};

const yourWorkPageRouteNames = [ROUTE_NAMES.YOUR_WORK, ROUTE_NAMES.HOME_ONBOARDING_REDIRECT];

export const useIsYourWorkTourCompleted = () => {
	const licensedProducts = useLicensedProducts();
	const route = useCurrentRoute();
	const [{ isCompleted }] = useStore();

	// only JSM users will see your work tour, otherwise just return as complete
	if (!licensedProducts || !licensedProducts[SERVICE_DESK]) {
		return true;
	}

	// other message can be global, not only on your work page
	// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"home-onboarding-redirect" | "your-work"'.
	const isOnYourWorkPage = yourWorkPageRouteNames.includes(route.name);
	if (!isOnYourWorkPage) {
		return true;
	}

	return isCompleted;
};
